import { useEffect, useState } from "react";
import { useAuth } from "../../Providers/AuthProvider";
import { getNaturePlanPriceListService } from "../../services/getNaturePlanPriceList";
import ContentLoading from "../Loading/Loading";
import nothing from "../../assets/images/adminPanel/nothing.jpg";
import { FormControlLabel, Switch } from "@material-ui/core";
import Spinner from "../spinner/Spinner";
import { CircularProgress } from "@mui/material";

const NaturePlanPriceList = ({
  PackageId,
  loadPackagePlanPrice,
  submitTracker,
  changeStateHandler,
  changedToggleLoading,
  setChangedToggleLoading,
}) => {
  const { stateAuth } = useAuth();
  const [planList, setPlanList] = useState([]);
  const [loading, setLoading] = useState(changedToggleLoading ? false : true);
  useEffect(() => {
    const requestData = {
      PackageId: PackageId,
    };
    const getNaturePlanPriceList = async () => {
      setLoading(changedToggleLoading ? false : true);
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await getNaturePlanPriceListService(
          requestData,
          header
        );
        setPlanList(data.Value);
        setLoading(false);
        setChangedToggleLoading("");
      } catch (error) {
        console.log(error);
      }
    };
    getNaturePlanPriceList();
  }, [submitTracker]);

  console.log("changedToggleLoading", changedToggleLoading);

  if (loading) {
    return <ContentLoading />;
  }
  return planList && planList.length !== 0 ? (
    <>
      <div className="hidden lg:flex lg:w-full gap-1 bg-darkGreenKite px-1 py-2 rounded-md">
        <div className="w-[8%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          ردیف
        </div>
        <div className="w-[9%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          ظرفیت
        </div>
        <div className="w-[19%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          تاریخ برگزاری
        </div>
        <div className="w-[16%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          مبلغ بزرگسال
        </div>
        <div className="w-[16%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          مبلغ کودک
        </div>

        <div className="w-[8%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          نوع ارز
        </div>
        <div className="w-[12%] text-center text-white border border-0 border-l border-white px-1 text-sm">
          وضعیت
        </div>
        <div className="w-[8%] text-center text-white px-1 text-sm">ویرایش</div>
      </div>

      <div className="flex flex-col w-full lg:mt-2">
        {planList.map((row, index) => (
          <div
            key={row.index}
            className="flex lg:w-full flex-wrap justify-between lg:justify-start gap-y-1 lg:gap-1 mb-4 lg:mb-2 lg:bg-slate-100 lg:rounded-md"
          >
            <div className="hidden lg:flex lg:items-center justify-center w-[8%] lg:text-sm">
              {index + 1}
            </div>
            <div className="w-[49.5%] lg:w-[9%] flex flex-col items-center justify-center gap-y-1 bg-slate-200 lg:bg-transparent rounded-sm py-2">
              <span className="text-xs text-slate-700 lg:hidden">ظرفیت</span>
              <span className="lg:text-xs">{row.Load}</span>
            </div>
            <div className="w-[49.5%] lg:w-[18%] flex flex-col items-center justify-center gap-y-1 bg-slate-200 lg:bg-transparent rounded-sm py-2">
              <span className="text-xs text-slate-700 lg:hidden">
                تاریخ برگزاری
              </span>
              <span className="lg:text-xs">{row.PDateTime}</span>
            </div>
            <div className="w-[49.5%] lg:w-[16%] flex flex-col items-center justify-center gap-y-1 bg-slate-200 lg:bg-transparent rounded-sm py-2">
              <span className="text-xs text-slate-700 lg:hidden">
                مبلغ بزرگسال
              </span>
              <span className="lg:text-xs">
                {row.AdultPrice.toLocaleString()} ریال
              </span>
            </div>
            <div className="w-[49.5%] lg:w-[16%] flex flex-col items-center justify-center gap-y-1 bg-slate-200 lg:bg-transparent rounded-sm py-2">
              <span className="text-xs text-slate-700 lg:hidden">
                مبلغ کودک
              </span>
              <span className="lg:text-xs">
                {row.ChildPrice.toLocaleString()} ریال
              </span>
            </div>

            <div className="w-[49.5%] lg:w-[8%] flex flex-col items-center justify-center gap-y-1 bg-slate-200 lg:bg-transparent rounded-sm py-2">
              <span className="text-xs text-slate-700 lg:hidden">نوع ارز</span>
              <span className="lg:text-xs">{row.Currency}</span>
            </div>
            <div className="w-[49.5%] lg:w-[12%] flex flex-col items-center justify-center gap-y-1 bg-slate-200 lg:bg-transparent rounded-sm py-2">
              <span className="text-xs text-slate-700 lg:hidden">وضعیت</span>
              <span className="lg:text-xs">
                {changedToggleLoading === row.Id ? (
                  <CircularProgress />
                ) : (
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked={row.State === 0 ? true : false}
                        onChange={(e) => changeStateHandler(e, row.Id)}
                      />
                    }
                  />
                )}
              </span>
            </div>
            <div className="w-full lg:w-[8%] flex flex-col items-center justify-center py-3 bg-slate-200 lg:bg-transparent rounded-sm md:py-1 text-xs">
              <button onClick={() => loadPackagePlanPrice(row.Id)}>
                ویرایش
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  ) : (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="w-60 h-60">
        <img className="w-full h-full" src={nothing} />
      </div>
      <div className="text-sm text-orangeKite">
        برنامه قیمتی و تاریخ برگذاری تور وارد نشده است.
      </div>
    </div>
  );
};

export default NaturePlanPriceList;
